import { render, staticRenderFns } from "./product-added-modal.component.vue?vue&type=template&id=b44f1cd0&"
import script from "./product-added-modal.component.vue?vue&type=script&lang=ts&"
export * from "./product-added-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./product-added-modal.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "product-added-modal.component.vue"
export default component.exports